module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_9005.d690ce98.png";